import { createSlice } from '@reduxjs/toolkit';
import api from '../api/api';
import { Routes } from "../routes";

// Función para decodificar JWT
const parseJwt = (token) => {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
};

const getRolesFromToken = (token) => {
    const decoded = parseJwt(token);
    return (decoded && decoded.roles) ? decoded.roles : [];
};

const getUsernameFromToken = (token) => {
    const decoded = parseJwt(token);
    return decoded ? decoded.sub : null;
};

const initialState = {
    token: localStorage.getItem('token') || null,
    loading: false,
    error: null,
    isAuthenticated: !!localStorage.getItem('token'),
    roles: localStorage.getItem('token') ? getRolesFromToken(localStorage.getItem('token')) : [],
    username: localStorage.getItem('token') ? getUsernameFromToken(localStorage.getItem('token')) : null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        loginSuccess: (state, action) => {
            state.loading = false;
            state.token = action.payload;
            state.isAuthenticated = true;
            state.roles = getRolesFromToken(action.payload);
            state.username = getUsernameFromToken(action.payload);
            state.redirectPath = Routes.DashboardOverview.path;
            localStorage.setItem("isAuthenticated", "true");


        },
        loginFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        logout: (state) => {
            state.token = null;
            state.isAuthenticated = false;
            localStorage.removeItem("isAuthenticated");
        },
        clearRedirect: (state) => {
            state.redirectPath = null;
        },
        clearError: (state) => {
            state.error = null;
        },
    },
});

export const { loginRequest, loginSuccess, loginFailure, logout, clearRedirect, clearError } = authSlice.actions;

export const login = (username, password) => async (dispatch) => {
    dispatch(loginRequest());
    try {
        const response = await api.post('api/auth/login', { username, password });
        const token = response.data.token;

        localStorage.removeItem('token'); // Limpiamos cualquier token previo
        localStorage.setItem('token', token);  // Guardamos el token en localStorage
        dispatch(loginSuccess(token));
    } catch (error) {
        // Extract error message from API response
        let errorMessage = 'Usuario y contraseña inválida';

        if (error.response?.data) {
            // If the response is a string, use it directly
            if (typeof error.response.data === 'string') {
                errorMessage = error.response.data;
            } else if (error.response.data.message) {
                // If it's an object with a message property
                errorMessage = error.response.data.message;
            } else if (error.response.data.error) {
                // Some APIs use 'error' instead of 'message'
                errorMessage = error.response.data.error;
            }
        }

        dispatch(loginFailure(errorMessage));
    }
};

export const performLogout = () => (dispatch) => {
    localStorage.removeItem('token');
    localStorage.removeItem('isAuthenticated');
    dispatch(logout());
};

export default authSlice.reducer;
